import { Box, Group } from '@byecode/ui'
import type { ExtractParams } from '@lighthouse/shared'
import React, { useState } from 'react'

import { typeName } from './index'
import { ParameterModal } from './ParameterModal'
import * as SC from './styles'

type ExtractQueryParamsProps = {
    options: { label: string; value: string }[]
    value: ExtractParams[]
    onChange: (value: ExtractParams[]) => void
}
const ExtractQueryParams: React.FC<ExtractQueryParamsProps> = ({ options, value, onChange }) => {
    const [open, setOpen] = useState(false)
    const [key, setKey] = useState(-1)
    const list = value || []
    const handleSubmit = (values: ExtractParams, type: 'add' | 'update') => {
        setOpen(false)

        const newList = [...list]
        if (type === 'add') {
            newList.push(values)
        } else {
            newList[key] = values
        }
        onChange(newList)
    }

    return (
        <>
            <Group
                label="参数提取"
                extra={[
                    <SC.Icon
                        style={{ marginLeft: 8 }}
                        onClick={e => {
                            setKey(-1)
                            setOpen(true)
                            e.stopPropagation()
                        }}
                        key={1}
                        type="Add2"
                        size={20}
                    />
                ]}
            >
                <Box px={8}>
                    {list.map((item, index) => {
                        return (
                            <SC.Item key={item.id}>
                                <SC.ItemHeader>
                                    <SC.ItemLeft>
                                        <SC.ParameterType>{item.name}</SC.ParameterType>
                                        <SC.ParameterText>{typeName(item.innerType)}</SC.ParameterText>

                                        <SC.ParameterRequired>{item.required && '必填'}</SC.ParameterRequired>
                                    </SC.ItemLeft>
                                    <SC.ItemRight>
                                        <SC.Icon
                                            type="NotePencil"
                                            size={16}
                                            onClick={() => {
                                                setKey(index)
                                                setOpen(true)
                                            }}
                                        />
                                        <SC.Icon
                                            type="Trash"
                                            style={{ marginLeft: '8px' }}
                                            size={16}
                                            onClick={() => {
                                                const newList = [...list]
                                                newList.splice(index, 1)
                                                onChange(newList)
                                            }}
                                        />
                                    </SC.ItemRight>
                                </SC.ItemHeader>
                                <SC.ItemContent>{item.description}</SC.ItemContent>
                            </SC.Item>
                        )
                    })}
                </Box>
            </Group>
            <ParameterModal
                isOpen={open}
                onclose={() => setOpen(false)}
                onOk={handleSubmit}
                currentIndex={key}
                list={list}
                options={options}
            />
        </>
    )
}

export default ExtractQueryParams
